import { supabase } from '@/lib/supabase'
import { useEffect, useState } from 'react'

/**
 * Number of stories in the signed-in user's bank, or null until known.
 * A head-only count: no rows (and none of their text) cross the wire. RLS scopes it to
 * the caller, so there is deliberately no user_id filter here.
 */
export function useStoryCount(): number | null {
  const [count, setCount] = useState<number | null>(null)

  useEffect(() => {
    let cancelled = false
    void supabase
      .from('story_banks')
      .select('id', { count: 'exact', head: true })
      .then(({ count: c, error }) => {
        if (!cancelled && !error) setCount(c ?? 0)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return count
}
